/*
|--------------------------------------------------------------------------
| Analytics: Chartbeat
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.chartbeat = {

	/**
	 * Initialize
	 */
	"init": function(){
	   	var commonJS			= __gh__webApp.common,
			checkChartbeatID	= commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"analytics.chartbeat.id");
		if(!checkChartbeatID){console.log("Chartbeat ID is not set.");return;}

		var chartbeatID 		= __gh__coreData["3rdPartyData"].analytics.chartbeat.id;
		if (!chartbeatID){return;}

		// Add variables to head section
		__gh__webApp.common.loadScript({
			"text"			: "var _sf_startpt=(new Date()).getTime(), _sf_async_config;"
		});

		//Config
		this.config(chartbeatID);

	    //Library
		this.loadLibrary();
	},

	/**
	 * Set Configuration
	 */
	 "config": function(chartbeatID) {
		 // Set vars
		var domain 		= __gh__coreData.siteData.domain,
			section 	= '', // need to get from feed
			author		= ''; // neeed to get from feed on article page

		//Config
		_sf_async_config 				= _sf_async_config || {};
	    _sf_async_config.uid 			= chartbeatID; 				//Change this to your chartbeat id number
	    _sf_async_config.domain 		= domain; 					//Change this to your domain name
	    _sf_async_config.useCanonical 	= true;
	    _sf_async_config.sections 		= section; 					//Change this to your Section name
	    _sf_async_config.authors 		= author; 					//Change this to your Author name
	 },


	/**
	 * Load Chartbeat library
	 */
	 "loadLibrary":function() {
		 (function() {
	        function loadChartbeat() {
	            window._sf_endpt = (new Date()).getTime();
	            var e = document.createElement('script');
	            e.setAttribute('language', 'javascript');
	            e.setAttribute('type', 'text/javascript');
	            e.setAttribute('src', '//static.chartbeat.com/js/chartbeat.js');
	            document.body.appendChild(e);
	        }
	        var oldonload = window.onload;
	        window.onload = (typeof window.onload != 'function') ?
	            loadChartbeat : function() {
	                oldonload();
	                loadChartbeat();
	            };
	    })();
	}
};
